"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _ConnectionLoader = require("@ccw-pwa-ui/ConnectionLoader");
require("./userIndex.css");
var _reactRouterDom = require("react-router-dom");
var _Services = require("../../common_features/utility/Services");
var _strings = require("../../common_features/utility/strings");
var _UserManageComponent = _interopRequireDefault(require("../../components/UserDashboard/UserManageComponent"));
var _RoutePath = _interopRequireDefault(require("../../RoutePath"));
var _reactRedux = require("react-redux");
var _manageUserReducer = require("../../common_features/redux/reducers/manageUserReducer");
var _images = _interopRequireWildcard(require("../../common_features/assets/images"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function UserDashbaord(_ref) {
  let {
    users,
    isLoading
  } = _ref;
  const navigate = (0, _reactRouterDom.useNavigate)();
  const dispatch = (0, _reactRedux.useDispatch)();
  const [isModalLoading, setIsModalLoading] = (0, _react.useState)(false);
  const [inputVal, setInputVal] = (0, _react.useState)('');
  const [selectVal, setSelectVal] = (0, _react.useState)({
    key: "all",
    title: "Select"
  });
  const [allSelect, setAllSelect] = (0, _react.useState)(false);
  const [disabled, setDisabled] = (0, _react.useState)(true);
  const [rowSelect, setRowSelect] = (0, _react.useState)([]);
  const [currentPage, setCurrentPage] = (0, _react.useState)(1);
  const pageSize = 10;
  const [totalUsers, setTotalUsers] = (0, _react.useState)(0);
  const [reInviteModal, setReInviteModal] = (0, _react.useState)(false);
  const [deleteModal, setDeleteModal] = (0, _react.useState)(false);
  const [orgNames, setOrgNames] = (0, _react.useState)([]);
  const {
    userInfo,
    userRoles
  } = (0, _reactRedux.useSelector)(state => state.login);
  const {
    Organization,
    ServiceProvider
  } = (0, _reactRedux.useSelector)(state => {
    var _state$userDetails;
    return state === null || state === void 0 ? void 0 : (_state$userDetails = state.userDetails) === null || _state$userDetails === void 0 ? void 0 : _state$userDetails.data;
  });
  const [resendButtonState, setResendButtonState] = (0, _react.useState)(false);
  const [expiredUserList, setExpiredUserList] = (0, _react.useState)([]);
  const [statusModal, setStatusModal] = (0, _react.useState)(false);
  const [errorModal, setErrorModal] = (0, _react.useState)(false);
  const [errorModalData, setErrorModalData] = (0, _react.useState)({
    ErrorModalHeaderText: "User Does not Exist",
    ErrorModalDetailText: "User must have been deleted from the account. Please refesh the Page"
  });
  const headerSchema = [{
    firstName: "First Name",
    lastName: "Last Name"
  }, {
    email: "Email"
  }, {
    createdAt: "Date Joined"
  }, {
    invitationStatus: "Status"
  }];
  const dropdownList = [{
    "title": "Select",
    "key": "all",
    value: 'Select'
  }, {
    "title": "First Name",
    "key": "firstName"
  }, {
    "title": "Last Name",
    "key": "lastName"
  }, {
    "title": "Status",
    "key": "invitation_status"
  }];
  const statusModalShow = () => {
    if (!statusModal) {
      setStatusModal(true);
    } else {
      setStatusModal(false);
    }
  };
  const validateUserStatus = () => {
    let selectedStates = [];
    let expiredUserList = [];
    rowSelect.length && rowSelect.forEach(id => {
      orgNames.forEach(rowData => {
        if (rowData.id === id) {
          console.log(rowData.invitationStatus);
          selectedStates = [...new Set([...selectedStates, rowData.invitationStatus])];
          if (["Invitation Expired", "Invitation Pending"].includes(rowData.invitationStatus)) {
            expiredUserList = [...expiredUserList, rowData.id];
          }
        }
        ;
      });
    });
    if (selectedStates.includes('Invitation Expired') || selectedStates.includes('Invitation Pending')) {
      setResendButtonState(false);
    } else {
      setResendButtonState(true);
    }
    setExpiredUserList(expiredUserList);
  };
  const setRowSelected = rowId => {
    if (allSelect) {
      setAllSelect(false);
      setRowSelect([rowId]);
      return;
    }
    const resultArr = rowSelect.filter(arrObj => arrObj !== rowId);
    if (resultArr.length === rowSelect.length) resultArr.push(rowId);
    setRowSelect(resultArr);
    validateUserStatus();
  };
  const setAllSelected = flag => {
    setAllSelect(flag);
    setRowSelect([]);
    if (flag) {
      setRowSelect(orgNames.map(rowData => {
        return rowData.id;
      }));
    } else {
      setRowSelect([]);
    }
  };
  const handlePageChange = pageNum => {
    setCurrentPage(pageNum);
    const configData = {
      limit: pageSize,
      pageNo: pageNum,
      attribute: selectVal.key,
      query: inputVal,
      userType: userInfo.serachUserType
    };
    fetchManagerUsers(configData);
  };
  function handleAddEmployee() {
    // navigate('/App/AddUserInvite')
    dispatch((0, _manageUserReducer.currentUserForEdit)({}));
    navigate(_RoutePath.default.addUserInvite.useLink);
  }
  (0, _react.useEffect)(() => {
    if (selectVal.key === dropdownList[0].key) {
      setInputVal('');
      setDisabled(true);
    } else {
      setDisabled(false);
    }
  }, [selectVal]);
  (0, _react.useEffect)(() => {
    const configData = {
      limit: pageSize,
      pageNo: currentPage,
      attribute: selectVal.key,
      query: inputVal,
      userType: userInfo.serachUserType
    };
    userInfo.serachUserType && fetchManagerUsers(configData);
    return null;
  }, [userInfo.serachUserType]);
  (0, _react.useEffect)(() => {
    if (rowSelect.length) validateUserStatus();
    return () => {};
  }, [rowSelect]);
  (0, _react.useEffect)(() => {
    const clearBtn = document.querySelector('.ant-input-clear-icon');
    clearBtn.onclick = () => {
      setCurrentPage(1);
      setSelectVal({
        key: "all",
        title: "Select"
      });
      const configData = {
        limit: pageSize,
        pageNo: currentPage,
        attribute: "",
        query: "",
        userType: userInfo.serachUserType
      };
      fetchManagerUsers(configData);
    };
    return () => {
      clearBtn.onclick = null;
    };
  }, [inputVal]);
  async function fetchManagerUsers(configData) {
    dispatch((0, _manageUserReducer.usersLoading)(true));
    setAllSelect(false);
    setRowSelect([]);
    await (0, _Services.fetchManagerUser)(configData).then(apiResp => {
      if (apiResp && apiResp.data && apiResp.data[userInfo.serachUserType] && apiResp.data[userInfo.serachUserType].rows) {
        handleBodySchema(apiResp.data[userInfo.serachUserType].rows);
        setTotalUsers(apiResp.data[userInfo.serachUserType].count);
        setOrgNames(apiResp.data[userInfo.serachUserType].rows);
      } else {
        setTotalUsers(0);
        dispatch((0, _manageUserReducer.usersLoading)(false));
        dispatch((0, _manageUserReducer.usersInfo)([]));
      }
    }).catch(error => {
      console.log(error);
      setTotalUsers(0);
      dispatch((0, _manageUserReducer.usersLoading)(false));
      dispatch((0, _manageUserReducer.usersInfo)([]));
    });
  }
  function handleBodySchema(userListArr) {
    const updatedUserList = userListArr.map(items => {
      let newDate = items.createdAt ? new Date(items.createdAt) : null;
      let dateFormat = newDate ? newDate.toLocaleDateString(undefined, {
        month: 'short'
      }) + " " + newDate.toLocaleDateString(undefined, {
        day: '2-digit'
      }) + ', ' + newDate.toLocaleDateString(undefined, {
        year: 'numeric'
      }) : "";
      let statusValue = _strings.USER_STATUS_TYPES[items.invitationStatus];
      items.createdAt = dateFormat;
      items.invitationStatus = items.emailVerified === false ? "Email Verification Pending" : statusValue;
      return items;
    });
    dispatch((0, _manageUserReducer.usersLoading)(false));
    dispatch((0, _manageUserReducer.usersInfo)(updatedUserList));
  }
  const handleSearch = () => {
    console.log('search result');
    const configData = {
      limit: pageSize,
      pageNo: currentPage,
      attribute: selectVal.key,
      query: inputVal,
      userType: userInfo.serachUserType
    };
    fetchManagerUsers(configData);
  };
  const handleResendInviteModal = async () => {
    const userRoleID = userRoles.filter(role => role.userType === userInfo.serachUserType);
    setIsModalLoading(true);
    setReInviteModal(false);
    const resendArrList = [];
    users.forEach(uList => {
      if (expiredUserList.includes(uList.id)) {
        const resendArrObj = {
          email: uList.email,
          "roleId": userRoleID[0].roleId
        };
        resendArrList.push(resendArrObj);
      }
    });
    await (0, _Services.resendInvite)(resendArrList).then(apiResp => {
      console.log(apiResp);
      if (apiResp && apiResp.success) {
        setIsModalLoading(false);
        const configData = {
          limit: pageSize,
          pageNo: currentPage,
          attribute: selectVal.key,
          query: inputVal,
          userType: userInfo.serachUserType
        };
        fetchManagerUsers(configData);
      } else {
        setErrorModal(true);
        setErrorModalData({
          ErrorModalHeaderText: "User does not exists",
          ErrorModalDetailText: "The user has been removed from this account. Please refresh your page."
        });
      }
    }).catch(error => {
      console.log(error);
      setIsModalLoading(false);
    });
  };
  const handleSetReInviteSubmitModal = e => {
    if (resendButtonState) return;
    setReInviteModal(true);
  };
  const handleSetDeleteSubmitModal = e => {
    setDeleteModal(true);
  };
  const handleSetReInviteCancelModal = e => {
    setReInviteModal(false);
  };
  const handleSetInputVal = e => {
    if (e.target.value.length > 0 && selectVal.key === "all") {
      setSelectVal(dropdownList[0]);
    }
    setInputVal(e.target.value);
  };
  const handleSetSelectVal = e => {
    setSelectVal(e);
  };
  const handleDeleteCancelModal = () => {
    setDeleteModal(false);
  };
  const handleDeleteModal = async rowId => {
    const resultingArray = rowSelect.filter(arrObject => arrObject !== rowId);
    let selectedStore = resultingArray;
    setDeleteModal(false);
    const requestPayload = {
      userIds: selectedStore,
      actionType: 1,
      userType: userInfo.serachUserType
    };
    setIsModalLoading(true);
    await (0, _Services.deleteUsers)(requestPayload).then(apiResp => {
      if (apiResp && apiResp.success) {
        setIsModalLoading(false);
        const config_Data = {
          limit: pageSize,
          pageNo: currentPage,
          attribute: selectVal.key,
          query: inputVal,
          userType: userInfo.serachUserType
        };
        fetchManagerUsers(config_Data);
      } else {
        setRowSelect([]);
        setIsModalLoading(false);
        setErrorModal(true);
        setErrorModalData({
          ErrorModalHeaderText: "User does not exists",
          ErrorModalDetailText: "The user has been removed from this account. Please refresh your page."
        });
      }
    }).catch(error => {
      setIsModalLoading(false);
      alert(error);
    });
  };
  const handleOnKeyPress = e => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };
  const getUsersForListing = () => {
    let usersList = users.map(user => {
      return {
        ...user,
        firstName: /*#__PURE__*/_react.default.createElement("span", {
          style: {
            fontWeight: 600,
            color: "#006E96",
            width: "100%"
          }
        }, user.firstName)
      };
    });
    return usersList;
  };
  const handleEmployeeRow = async (e, row, j) => {
    let userRole = userRoles.find(r => r.roleId === row.roleId);
    const detail = {
      firstName: row.firstName.props.children,
      lastName: row.lastName,
      email: row.email,
      id: row.id,
      address: row.address,
      phone: row.phone,
      userType: userRole.userType,
      editView: true
    };
    dispatch((0, _manageUserReducer.currentUserForEdit)(detail));
    navigate(_RoutePath.default.addUserInvite.useLink);
  };
  function handleErrorModel(mode) {
    setErrorModal(false);
    const configData = {
      limit: pageSize,
      pageNo: currentPage,
      attribute: selectVal.key,
      query: inputVal,
      userType: userInfo.serachUserType
    };
    userInfo.serachUserType && fetchManagerUsers(configData);
  }
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_UserManageComponent.default, {
    Loader: /*#__PURE__*/_react.default.createElement(_ConnectionLoader.ConnectionLoader, null),
    isModalLoading: isModalLoading,
    inviteModalVarient: "resend-invitation",
    modalHeaderText: /*#__PURE__*/_react.default.createElement("span", null, "Are you sure you want to ", /*#__PURE__*/_react.default.createElement("br", null), "resend invitation to the ", userInfo.userType === 4 ? "Employee" : "Technician", "(s)?"),
    modalDetailText: "Active or In Process ".concat(userInfo.userType === 4 ? "Employee" : "Technician", " will not receive an invitation"),
    reInviteModal: reInviteModal,
    deleteModal: deleteModal,
    positiveActionButtonTitle: "Send Invitation(s)",
    negativeButtonActionTitle: "Cancel",
    handleResendInviteModal: handleResendInviteModal,
    setReInviteModal: handleSetReInviteCancelModal,
    handleSetReInviteSubmitModal: handleSetReInviteSubmitModal,
    handleSetReInviteCancelModal: handleSetReInviteCancelModal,
    DeleteModal: true,
    deleteModalVariant: "remove-user-modal",
    deleteModalHeaderText: rowSelect && rowSelect.length === 1 ? "Are you sure you want to remove ".concat(rowSelect.length, " ").concat(userInfo.userType === 4 ? "Employee" : "Technician", "?") : "Are you sure you want to remove ".concat(rowSelect.length, " ").concat(userInfo.userType === 4 ? "Employees" : "Technicians", "?"),
    deleteModalDetailText: "This action cannot be undone.",
    positiveActionDeleteButtonTitle: rowSelect.length === 1 ? "Remove ".concat(rowSelect.length, " ").concat(userInfo.userType === 4 ? "Employee" : "Technician") : "Remove ".concat(rowSelect.length, " ").concat(userInfo.userType === 4 ? "Employees" : "Technicians"),
    negativeDeleteButtonActionTitle: "Cancel",
    handleDeleteModal: handleDeleteModal,
    handleSetDeleteSubmitModal: handleSetDeleteSubmitModal,
    handleDeleteCancelModal: handleDeleteCancelModal,
    headerTextTitle: orgNames,
    addEmployeeBtnTitle: "Add ".concat(userInfo.userType === 4 ? "Employee" : "Technician"),
    handleAddEmployee: handleAddEmployee,
    headerTextResendInvite: "Resend Invitation",
    inputPlaceHolder: "Search",
    inputVal: inputVal,
    setInputVal: handleSetInputVal,
    handleSearch: handleSearch,
    dropdownList: dropdownList,
    handleSetSelectVal: handleSetSelectVal,
    selectVal: selectVal,
    placeholderDropdown: "Please select",
    isLoading: isLoading,
    allowRowClick: true,
    headerSchema: headerSchema,
    usersList: getUsersForListing(),
    handleEmployeeRowClick: handleEmployeeRow,
    handleRowClick: true,
    setAllSelected: setAllSelected,
    allSelect: allSelect,
    rowSelect: rowSelect,
    setRowSelected: setRowSelected,
    totalUsers: totalUsers,
    currentPage: currentPage,
    pageSize: pageSize,
    handlePageChange: handlePageChange,
    users: users,
    subHeading: Organization !== null && Organization !== void 0 && Organization.name ? Organization === null || Organization === void 0 ? void 0 : Organization.name : ServiceProvider === null || ServiceProvider === void 0 ? void 0 : ServiceProvider.name,
    resendButtonState: resendButtonState,
    handleOnKeyPress: handleOnKeyPress,
    userStatusData: _strings.userStatusData,
    image: _images.default.Info.default,
    statusModalShow: statusModalShow,
    statusModalFlag: statusModal,
    userPersona: userInfo.userType === 4 ? "Employee" : "Technician",
    userInfo: userInfo,
    errorModal: errorModal,
    ErrorModalVariant: "remove-user-modal",
    ErrorModalHeaderText: errorModalData.ErrorModalHeaderText,
    ErrorModalDetailText: errorModalData.ErrorModalDetailText,
    customIcon: /*#__PURE__*/_react.default.createElement("img", {
      src: _images.warningSvg.default
    }),
    positiveActionErrorButtonTitle: "Continue",
    handleErrorModal: () => handleErrorModel(false),
    disabled: disabled
  }));
}
const mapStateToProps = state => ({
  users: state.users.users,
  isLoading: state.users.loading
});
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps)(UserDashbaord);